import ApiClient from './ApiClient';

class ProjectsClient extends ApiClient {
  constructor() {
    super('/subscriptions/v1/');
  }
}

const projectsClient = new ProjectsClient();

export default projectsClient;
